<!--
    AI:
    Status: "in progress"
    Type: Component
    SubType: ObjectBaseComponent
    Reason: Read-only detail of ONE contract in ONE run ("Verträge" tab): outcome, contract,
            Hauptvermittler, Fehlergrund (messages + "Was tun?") and the bookings of this run as a
            widget table with their sum. No write path.
-->
<div class="cp-run-detail-contract-run flex flex-column gap-3">

    @if (busy || (viewBusy && !view)) {
        <p-skeleton height="3rem"></p-skeleton>
        <p-skeleton height="6rem"></p-skeleton>
        <p-skeleton height="6rem"></p-skeleton>
    } @else if (!contractRunId) {
        <p-message severity="info" text="Kein Vertrag ausgewählt." styleClass="w-full"></p-message>
    } @else if (loadFailed) {
        <p-message severity="error" text="Der Vertrag dieses Laufs konnte nicht geladen werden." styleClass="w-full"></p-message>
        <div>
            <p-button label="Erneut laden" icon="fa-regular fa-arrows-rotate" severity="secondary"
                      [outlined]="true" size="small" (onClick)="retry()"></p-button>
        </div>
    } @else {
        @if (initialized && dto) {
            @if (view) {
                <!-- Contract + outcome -->
                <div class="flex align-items-start justify-content-between flex-wrap gap-2">
                    <div class="flex flex-column">
                        <span class="text-sm text-600">Vertrag (VSNR)</span>
                        <span class="text-xl font-semibold text-900">{{ view.contractIdentifier || view.contractId || '–' }}</span>
                        @if (view.contractTypeName) {
                            <span class="text-600">{{ view.contractTypeName }}</span>
                        }
                    </div>
                    <div class="flex align-items-center gap-2">
                        <p-tag [value]="getStatusLabel(contractRun.status)" [severity]="getStatusTag(contractRun.status)"></p-tag>
                        @if (contractRun.contractDtoId) {
                            <p-button label="Vertrag öffnen"
                                      icon="fa-regular fa-arrow-up-right-from-square"
                                      severity="secondary" [text]="true" size="small"
                                      (onClick)="openContract()">
                            </p-button>
                        }
                    </div>
                </div>

                <!-- Hauptvermittler -->
                <div class="flex flex-column gap-1">
                    <span class="text-sm text-600">Hauptvermittler</span>
                    <cp-run-detail-agent-list
                            [agents]="view.mainAgents"
                            emptyText="Zum Vertrag ist kein Hauptvermittler eingetragen.">
                    </cp-run-detail-agent-list>
                </div>

                <!-- Fehlergrund / Meldungen -->
                <div class="flex flex-column gap-2">
                    <span class="text-sm text-600">Meldungen dieses Vertrags im Lauf</span>
                    @for (message of view.messages; track message.id) {
                        <div class="border-1 surface-border border-round p-2 flex flex-column gap-1">
                            <div class="flex align-items-center gap-2 flex-wrap">
                                <p-tag [value]="getSeverityLabel(message.severity)" [severity]="getSeverityTag(message.severity)"></p-tag>
                                <span class="font-semibold text-900">{{ message.messageCode }}</span>
                                @if (message.obsolete) {
                                    <p-tag value="Veraltet" severity="secondary"></p-tag>
                                }
                            </div>
                            <span class="text-900 line-height-3">{{ message.message }}</span>
                            @if (message.detailedMessage) {
                                <span class="text-sm text-700">{{ message.detailedMessage }}</span>
                            }
                            <span class="text-sm text-600 line-height-3">
                                <i class="fa-regular fa-lightbulb text-primary mr-1"></i>{{ getGuidance(message) }}
                            </span>
                        </div>
                    } @empty {
                        <span class="text-600 text-sm">Keine Meldungen zu diesem Vertrag.</span>
                    }
                </div>

                <!-- Buchungen / Betrag -->
                <div class="flex flex-column gap-2">
                    <span class="text-sm text-600">Buchungen dieses Laufs</span>
                    @if (bookingsWidget) {
                        <mvs-widget [widgetData]="bookingsWidget" (onLoadData)="handleBookingsLoaded($event)"></mvs-widget>
                        @if (bookingsFailed) {
                            <span class="text-red-500 text-sm">Buchungen konnten nicht geladen werden.</span>
                        } @else if (bookingsLoaded && bookingCount > 0) {
                            <div class="flex justify-content-between align-items-center surface-ground border-round p-2">
                                <span class="font-semibold text-900">Summe</span>
                                <span class="font-semibold text-900">{{ bookingTotal | currency:'EUR':'symbol':'1.2-2' }}</span>
                            </div>
                        } @else if (bookingsLoaded) {
                            <span class="text-600 text-sm">Dieser Lauf hat für den Vertrag keine Buchung erzeugt.</span>
                        }
                    } @else {
                        <span class="text-600 text-sm">Dieser Lauf hat für den Vertrag keine Buchung erzeugt.</span>
                    }
                </div>
            }
        }
    }

</div>
